const flatten = require('lodash/flatten');
const values = require('lodash/values');
const groupBy = require('lodash/groupBy');
const mapValues = require('lodash/mapValues');
const map = require('lodash/map');
const find = require('lodash/find');

const app = angular.module('msi.oneTimeDifferences.oneTimeDifferencesFactory', []);

function oneTimeDifferencesFactory(ogProductLocaleFilter) {
  return class oneTimeDifferences {
    constructor() {
      this.itemDifferences = {
        quantity: [],
        shipping: [],
        billing: []
      };
    }

    addItemDifferences(item, shipment) {
      if (!item.subscription) {
        return;
      }

      function detectAndAddDifference(differencesList, shipmentValue, subscriptionValue) {
        if (shipmentValue !== subscriptionValue) {
          const productName = ogProductLocaleFilter(item.product, 'name');
          const itemPublicId = item.publicId;
          if (!find(differencesList, itemInList => itemInList.itemPublicId === item.publicId)) {
            differencesList.push({ productName, shipmentValue, subscriptionValue, itemPublicId });
          }
        }
      }

      detectAndAddDifference(this.itemDifferences.quantity, item.quantity, item.subscription.quantity);
      detectAndAddDifference(this.itemDifferences.shipping, shipment.shippingAddressId, item.subscription.shippingAddressId);
      detectAndAddDifference(this.itemDifferences.billing, shipment.paymentId, item.subscription.paymentId);
    }

    get hasDifferences() {
      return flatten(values(this.itemDifferences)).length > 0;
    }

    get hasQuantityDifferences() {
      return this.itemDifferences.quantity.length > 0;
    }

    get hasBillingDifferences() {
      return this.itemDifferences.billing.length > 0;
    }

    get hasShippingDifferences() {
      return this.itemDifferences.shipping.length > 0;
    }

    get productsByDifferentShipping() {
      const grouped = groupBy(this.itemDifferences.shipping, 'subscriptionValue');
      return mapValues(grouped, diff => map(diff, 'productName'));
    }

    get productsByDifferentPayments() {
      const groupByPayment = groupBy(this.itemDifferences.billing, 'subscriptionValue');
      const ProductsByDifferentPayments = mapValues(groupByPayment, diff => map(diff, 'productName'));
      return ProductsByDifferentPayments;
    }

    get quantityDifferences() {
      return this.itemDifferences.quantity;
    }
  };
}

oneTimeDifferencesFactory.$inject = ['ogProductLocaleFilter'];

app.service('OneTimeDifferences', oneTimeDifferencesFactory);

module.exports = app.name;
